module.exports = __webpack_public_path__ + "img/recharge1.9cf1bde8.png";